class BestyleCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.track = this.querySelector('[data-bestyle-recommendations-track]');
    this.previousButton = this.querySelector('[data-bestyle-recommendations-previous]');
    this.nextButton = this.querySelector('[data-bestyle-recommendations-next]');

    this.previousButton?.addEventListener('click', () => this.scrollByCard(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.scrollByCard(1), { signal });
    this.track?.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
    window.addEventListener('resize', () => this.updateControls(), { passive: true, signal });

    requestAnimationFrame(() => this.updateControls());
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  scrollByCard(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('.bestyle-cart-recommendations__card');
    if (!card) return;

    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: 'smooth',
    });
  }

  updateControls() {
    if (!this.track) return;
    const maxScrollLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const currentScrollLeft = Math.abs(this.track.scrollLeft);

    if (this.previousButton) this.previousButton.disabled = currentScrollLeft < 3;
    if (this.nextButton) this.nextButton.disabled = currentScrollLeft > maxScrollLeft - 3;
  }
}

if (!customElements.get('bestyle-cart-recommendations')) {
  customElements.define('bestyle-cart-recommendations', BestyleCartRecommendations);
}